// extracted by mini-css-extract-plugin
export default {"container":"AttributeSections_container__+i1fk"};